import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { EntityProp, EntityPropList, ePropType } from '@abp/ng.components/extensible';
import { formatDate } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { SaasTenantDto, TenantActivationState } from '@volo/abp.ng.saas/proxy';
import { of } from 'rxjs';
import { eTenantManagementComponents, TenantManagementEntityPropContributors } from '@abp/ng.tenant-management';
import { DEFAULT_TENANTS_ENTITY_PROPS, eSaasComponents, SaasEntityPropContributors } from '@volo/abp.ng.saas';

const activationStateProp = new EntityProp<SaasTenantDto>({
    type: ePropType.String,
    name: 'activationState',
    displayName: 'Saas::ActivationState',
    columnWidth: 300,
    valueResolver: data => {
      const localization = data.getInjected(LocalizationService);
      const configState = data.getInjected(ConfigStateService);
      const localeId = data.getInjected(LOCALE_ID);

      const { shortDatePattern, shortTimePattern } = configState.getDeep(
        'localization.currentCulture.dateTimeFormat',
      );

      let result = '';
      switch (data.record.activationState) {
        case TenantActivationState.Active:
          result = localization.instant('Saas::Enum:TenantActivationState.Active');
          return of(result);
        case TenantActivationState.ActiveWithLimitedTime:
          const activationEndDate = new Date(data.record.activationEndDate);
        const currentDate = new Date();
        if (activationEndDate < currentDate) {
          result = localization.instant('Expirado');
        } else {
          result = `${localization.instant(
            'Saas::Enum:TenantActivationState.ActiveWithLimitedTime',
          )} (${formatDate(
            data.record.activationEndDate,
            `${shortDatePattern} ${shortTimePattern.replace('tt', 'a')}`,
            localeId,
          )})`;
        }
        return of(result);
        case TenantActivationState.Passive:
          result = localization.instant('Saas::Enum:TenantActivationState.Passive');
          return of(result);
      }
    },
  },
);

export function activationStatePropContributor(propList: EntityPropList<SaasTenantDto>) {
  const index = propList.findIndex(prop => prop.value.name === 'activationState');

  const expDateIdx = propList.findIndex(prop => prop.value.name === 'editionEndDateUtc')
  const expDateNameIdx = propList.findIndex(prop => prop.value.name === 'editionName')

  if(index != -1)
  {
    propList.dropByIndex(index)
    propList.dropByIndex(expDateIdx)
    propList.dropByIndex(expDateNameIdx)
  }

  propList.addTail(activationStateProp)
}

export const activationStatePropContributors: SaasEntityPropContributors = {
  // enum indicates the page to add contributors to
  [eSaasComponents.Tenants]: [
    activationStatePropContributor,
    // You can add more contributors here
  ],
};
